import React from 'react';

interface FigureProps {
  src: string;
  alt: string;
  caption?: string;
  source?: string;
  position?: 'left' | 'right' | 'center';
  size?: 'extra-small' | 'small' | 'medium' | 'large';
  className?: string;
}

const Figure: React.FC<FigureProps> = ({ 
  src, 
  alt, 
  caption, 
  source, 
  position = 'center', 
  size = 'medium',
  className = '' 
}) => {
  const sizeClasses = {
    'extra-small': 'max-w-56',
    small: 'max-w-xs md:max-w-sm',
    medium: 'max-w-sm md:max-w-md lg:max-w-lg',
    large: 'max-w-md md:max-w-lg lg:max-w-xl'
  };

  const positionClasses = {
    left: 'mx-auto mb-6',
    right: 'mx-auto mb-6', 
    center: 'mx-auto mb-6'
  };

  const containerClasses = `
    ${sizeClasses[size]} 
    ${positionClasses[position]} 
    transition-all 
    duration-300
    ${className}
  `.trim();

  return (
    <figure className={containerClasses}>
      <div className="relative overflow-hidden">
        <img 
          src={src}
          alt={alt}
          className="w-full h-auto object-cover block"
          loading="lazy"
          decoding="async"
        />
      </div>
      {(caption || source) && (
        <figcaption className="mt-3 text-sm text-center px-2">
          {caption && (
            <span 
              className="block text-[var(--color-text-secondary)] mb-1"
              style={{ fontFamily: 'Short Stack, cursive' }}
            >
              {caption}
            </span>
          )}
          {source && (
            <span 
              className="block text-[var(--color-text-muted)] italic text-xs"
              style={{ fontFamily: 'Short Stack, cursive' }}
            >
              Source: {source}
            </span>
          )}
        </figcaption>
      )}
    </figure>
  );
};

export default Figure;